var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-sea-house" },
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "30%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "padding-bottom": "5px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.showTipDialog }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "500px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "row-selection": _vm.rowSelection
            },
            on: { gridReady: _vm.gridReady }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "sea-house-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("SeaExport.MattersNeedingAttention")
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-txt" }, [
            _c("h6", [
              _c("i", { staticClass: "el-icon-warning icon-tip" }),
              _vm._v(_vm._s(_vm.$t("queryJob.NewExportClearancePolicy")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("queryJob.NewExportClearancePolicyTip")))
            ]),
            _c("ul", [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("queryJob.YangshanAreaNovember152021")))
              ]),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("queryJob.WaigaoqiaoAreaNovember222021")))
              ])
            ]),
            _c("h6", [
              _c("i", { staticClass: "el-icon-warning icon-tip" }),
              _vm._v(_vm._s(_vm.$t("queryJob.GarbageManifest")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("queryJob.N1OnceTheManifestManifest")))
            ]),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("queryJob.N2ManifestMustBeDeletion")))
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("queryJob.N3YuanOnTheManifest")))])
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.hanldeRemindNext },
                  model: {
                    value: _vm.notRemindNextTime,
                    callback: function($$v) {
                      _vm.notRemindNextTime = $$v
                    },
                    expression: "notRemindNextTime"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.DontRemindMeAgain")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSeaHouse }
                },
                [_vm._v(_vm._s(_vm.$t("Message.ConfirmSending")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.ReturnToModify")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }